import * as devisConf from '@/configuration/devisConf';
import calculArrondi from '@/services/calcul/calculArrondi';

export default function calculLignesRemise(ligneCommande) {
  if (ligneCommande == null) {
    return;
  }

  ligneCommande.remise = 0;

  if (ligneCommande.totalAvantRemise === null
    || ligneCommande.totalAvantRemise === undefined
    || ligneCommande.totalAvantRemise === 0) {
    ligneCommande.totalHt = 0;
    return;
  }

  ligneCommande.totalHt = ligneCommande.totalAvantRemise;
  if (ligneCommande.lignesRemise === null
    || ligneCommande.lignesRemise === undefined
    || ligneCommande.totalAvantRemise === 0) {
    return;
  }

  let montantDesRemises = 0;
  ligneCommande.lignesRemise.sort((a, b) => {
    return a.ordre - b.ordre;
  });

  ligneCommande.lignesRemise.forEach((ligneRemise, index) => {
    if (ligneRemise.type === devisConf.TYPE_REMISE_SOUS_TOTAL) {
      ligneRemise.montant = ligneCommande.totalHt;
      return;
    }
    ligneRemise.montant = 0;
    ligneRemise.montantARemise = 0;

    let totalAvantRemise = ligneCommande.totalAvantRemise;
    const lignesSousTotal = ligneCommande.lignesRemise
      .slice(0, index + 1)
      .filter((ligneRemise) => ligneRemise.type === devisConf.TYPE_REMISE_SOUS_TOTAL);
    if (lignesSousTotal.length) {
      totalAvantRemise = lignesSousTotal[lignesSousTotal.length - 1].montant;
    }

    switch (ligneRemise.type) {
      case devisConf.TYPE_REMISE_CUMULE:
        ligneRemise.montantARemise = totalAvantRemise;
        break;
      case devisConf.TYPE_REMISE_CASCADE:
        ligneRemise.montantARemise = ligneCommande.totalHt;
        break;
      default:
        ligneRemise.montantARemise = 0;
        break;
    }

    switch (ligneRemise.typeRemise) {
      case devisConf.MONTANT:
        ligneRemise.montant = ligneRemise.remise;
        break;
      case devisConf.POURCENTAGE:
        ligneRemise.montant = calculArrondi(ligneRemise.remise * ligneRemise.montantARemise / 100);
        break;
      default:
        ligneRemise.montant = 0;
        break;
    }

    ligneCommande.totalHt = calculArrondi(ligneCommande.totalHt + ligneRemise.montant);
    montantDesRemises = calculArrondi(montantDesRemises + ligneRemise.montant);
  });
  ligneCommande.remise = calculArrondi(montantDesRemises * 100
    / ligneCommande.totalAvantRemise, 5);
}
